module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAQCAYAAADNo/U5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAATlJREFUeNqM07FLAmEYx3FPLVFSIsWgPyCsoQaXloywqaYwrD+gEIqCoKWhpcagWqKGZpuiIBoDwabEaFAQgxxapCAIgrCi+j7wGC+HVx58jvfu3t+97/u8d9ZJ37SrzWMB3zjy6o0hvOHOIdCFLYSlr5vTInK4QcYhtIJeyCAJCXWiW992gB1bIIQ1bdcw5ZkNDlzTeMKwdhjBB/La8QKDeMckKjLSF/YRQwkWNjW8jKSGd1GQhmWrnkyxiH48Igi/jppodnLb5v+KCdQR1cCLGWgVkuMBl8Z1QMv9Z2gcM/jEla5ZqrfkFOpBFj6cYhQpNLCne+qSkpuhbR3pFmnjK2noC8ZQ9hqBdczjHnN4Np5Juc8QlzU3QxENebCKaou11tTvmmQ/OnCI8/8+d7MQx9ho5x/5EWAAEAg8zR7qXbAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wrong.png
// module id = 92
// module chunks = 0